// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"301":"error-page","776":"landing-page"}[chunkId] + ".dynamic." + {"301":"15d5342800a75a862138","776":"ed251c5414f903c74981"}[chunkId] + ".js";
};